import React from 'react';
import Loadable from 'react-loadable';
import Loader from '../../../../utils/Loader';

const AcceptJoinRequest = Loadable({
    loader: () => import('../index' /* webpackChunkName: "Authentication" */),
    loading() {
        return <Loader />;
    },
});

export default AcceptJoinRequest;
